const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-about-1',
		text: `<b>HHX er en forkortelse</b> - hvad står bogstaverne for?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `HHX er en gymnasial uddannelse med fokus på teknologi, naturvidenskab og praktiske projekter.`,
		answer: 'Højere Handels Eksamen',
		altAnswers: ['højere handelseksamen', 'højre Handelseksamen', 'højre handels eksamen'],
		subtype: 'string',
		unit: null,
		image: 'hhx-education-about-1',
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'education-about-2',
		text: `Hvor mange år tager en HHX-uddannelse som udgangspunkt?`,
		hintText: `I kan finde svaret her:  https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/merkantil-studentereksamen-hhx`,
		popupText: `En gymnasieuddannelse er bygget op, så man både når at have grundforløb og fordybelse i fagene.`,
		shuffleOptions: false,
		image: 'hhx-education-about-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: '1 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: '2 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: '3 år', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: '4 år'
			})
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'education-about-3',
		text: `Når man skal i skole på HHX, <b>hvilket udstyr tror I, man har brug for</b> for at være klar til en dag med fag og projekter?`,
		hintText: `Det handler om ting, man bruger hver dag i undervisningen.`,
		popupText: `Gymnasiet handler ikke kun om bøger – gruppearbejde, teknologi og fælles projekter fylder også meget.`,
		layout: 'htx-cool-school-items',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'laptop', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'books', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'group-work', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'phone'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'money',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'smartboard', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'chefs-hat',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'education-about-4',
		text: `Hvor mange elever tror I, der cirka starter på HHX hvert år i Danmark?`,
		hintText: `HHX findes mange steder i Danmark. Tænk over, hvor mange elever der starter hvert år - og at uddannelsen varer 3 år.`,
		popupText: `HHX er en landsdækkende gymnasial uddannelse med tusindvis af elever i hele Danmark.`,
		shuffleOptions: false,
		image: 'hhx-education-about-4',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Ca. 7.500'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ca. 10.000',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Ca. 12.500', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Ca. 15.000'
			})
		],
	}),

	/* Case 2 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-mc-3-characteristics',
		text: `Hvilke tre ting tror I, ofte beskriver elever, der vælger <b>HHX</b>?`,
		hintText: `Det kan findes på ug.dk hjemmesiden.`,
		popupText: `HHX tiltrækker elever, der interesserer sig for økonomi, virksomheder og markedsføring – og som motiveres af at arbejde med virkelige cases og forretningsidéer.`,
		image: 'hhx-eduction-education-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'De vil gerne vil lære om sprog, kultur, økonomi og samfund', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'De kan lide at arbejde praktisk med laboratorier, forsøg og projekter'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'De kan lide undervisning, der primært er teoretisk', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'De kan lide undervisning, der er både teoretisk og praktisk'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'De er klar over, at uddannelse kræver forberedelse og lektier i fritiden', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		taskId: 'education-sort-basic',
		title: 'Opgave 2',
		text: `Grundforløb på %school% – hvad hører med?
			<br /><br />I er nye på HHX og skal finde ud af, hvad der sker i grundforløbet. Kan I sortere det, der hører med, fra det, der ikke gør?`,
		hintText: `I kan finde svaret her: https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/merkantil-studentereksamen-hhx`,
		popupText: `Grundforløbet er den første tid på gymnasiet, hvor alle prøver fag og studieretninger, før man vælger sin endelige retning.`,
		layout: 'education-sort-basic',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'true', title: `Sandt om grundforløbet`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'false', title: `Falsk om grundforløbet`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Introduktion til fag og studieretninger`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `De første 3 måneder på HHX er grundforløb`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Alle på en skole har de samme fag på grundforløbet`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Introduktion til alle gymnasiets undervisere og vejledere`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Grundforløbet starter allerede efter de første 3 måneder`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Man vælger selv, hvilke fag man skal have på grundforløbet`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Under grundforløbet skal man besøge videregående uddannelser`, categoryIds: ['false']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'education-order-visit',
		title: 'Opgave 3',
		text: `<b>I dag handler det om %school%.</b> 
			<br />Hvad tror I, er de bedste ting at gøre, hvis %school% virker spændende? 
			<br />Sæt dem i den rækkefølge, I synes giver mest mening.`,
		hintText: `Det er i hvert falde en god ide at besøge et åbent hus.`,
		popupText: `Mange elever finder først ud af, om HHX er noget for dem, når de har været til åbent hus.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Prøve kræfter med %school%s HHX spil`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Skrive sig op til åbent hus direkte i spillet, når det er færdigt`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Læse mere på uddannelsesguiden - www.ug.dk`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Tale med sin vejleder og lærere`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Tage mor og far med til åbent hus`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Beslutte sig i god tid og ansøge`, correctOrderNumbers: [6]
			})
		]
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'education-order-university-job',
		title: 'Opgave 1',
		text: `Hvad tror I er rækkefølgen for en gymnasieelev, der drømmer om et job med en universitetsuddannelse? 
			<br /><br /><b>Sæt trinnene i rigtig rækkefølge – fra start til slut.</b>`,
		hintText: `Start med skolen og slut med jobbet.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Færdiggøre grundskolen`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Begynde på gymnasiet`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælge studieretning og fagpakke`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Gennemføre gymnasieeksamen`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Fuldføre videregående uddannelse`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Starte i job`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'education-sort-dreams',
		title: 'Opgave 2',
		text: `Hvilke jobs og karrierer tror I, mange HHX-elever går og drømmer om?`,
		hintText: `ChatGPT kan hjælpe jer godt på vej.`,
		popupText: `Mange HHX-elever drømmer om job inden for business, iværksætteri, økonomi og international handel.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'typical', title: `Typiske drømme`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notTypical', title: `Ikke typiske drømme`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Iværksætteri`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Reklame`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Finans`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Økonomi`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Ledelse`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Jura`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Internationalt job`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Revisor`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 9, text: `Frisør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 10, text: `Psykolog`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 11, text: `Læge`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 12, text: `Ingeniør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 13, text: `Dyrlæge`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 14, text: `Programmør`, categoryIds: ['notTypical']})
		]
	}),
	// Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
	// 	caseId: 3,
	// 	taskNumber: 3,
	// 	title: 'Opgave 2B',
	// 	taskId: 'education-paper-doll-doctor',
	// 	lockedById: 'education-sort-dreams',
	// 	layout: 'education-doctor',
	// 	avatarId: 'avatar-1',
	// 	text: `Et af jobbene, vi nævnte, var læge. Hvilket udstyr tror I, man bruger som læge? Vælg de ting, der passer bedst – og klik OK, når I synes, I har ramt rigtigt.`,
	// 	hintText: `Tænk på, hvad en læge bruger i hverdagen.`,
	// 	items: [
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'syringe-b', title: 'Sprøjte med nål', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'lab-coat-white', title: 'Hvid kittel', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'chart', title: 'Notatblok til journalføring', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'camera-b', title: 'Kamera'
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'paint-brush', title: 'Malerpensel'
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'safety-shoes', title: 'Sikkerhedssko'
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'stethoscope', title: 'Stetoskop', isCorrect: true
	// 		})
	// 	]
	// }),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 3',
		taskId: 'education-spot-errors-job-event',
		layout: 'education-job-event',
		text: `<b>Mange gymnasieelever tager til jobmesser og karriereevents.</b>
			<br /><br />På billedet ser I en elev til en jobmesse – men der er nogle ting, der ikke helt passer. Kan I finde dem? 
			<br /><br /><b>Klik OK, når I tror, I har alle.</b>`,
		hintText: `Kig på ting, der virker forkerte i et professionelt møde.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tie'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'chair'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'paper'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'cup'})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 5,
		title: 'Opgave 4',
		taskId: 'education-input-limits',
		text: `Hvis man vælger HHX, sætter det så grænser for, hvad man kan blive i fremtiden?`,
		hintText: `Gå med jeres fornemmelse.`,
		popupText: `HHX er faktisk den ungdomsuddannelse i Danmark, der giver adgang til flest uddannelser bagefter.`,
		answer: 'Nej',
		subtype: 'string',
		unit: null
	}),
	/* Case 4 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-fields-1',
		text: `Er det rigtigt, at alle gymnasier tilbyder alle eksisterende studieretninger?`,
		hintText: `Tænk på forskelle mellem små og store gymnasier.`,
		popupText: `Hvert gymnasium vælger selv, hvilke studieretninger de udbyder – derfor er der forskelle rundt i landet.`,
		image: 'hhx-education-fields-1',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Nej', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ja'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'education-fields-2',
		text: `Hvad tror I er rigtigt om studieretningerne?`,
		hintText: `I kan finde svaret her: https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/merkantil-studentereksamen-hhx`,
		popupText: `Studieretningen er central, fordi den bestemmer niveauer i fagene og dermed, hvilke videregående uddannelser man senere kan søge ind på.`,
		image: 'hhx-education-fields-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Du kan vælge studieretning hvert år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Valget af studieretning påvirker hvilke fag og niveauer du får', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Valg af studieretning kan have betydning for videregående uddannelser', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Alle studieretninger giver adgang til alle uddannelser'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3A',
		taskId: 'education-fields-3',
		text: `At vælge studieretning er noget, mange ser frem til, når de starter på gymnasiet – og der er masser at vælge imellem. 
			<br /><br /><b>Find de 3 billeder, der passer til HHX-studieretninger.</b>`,
		hintText: `Det kan googles på "HHX studieretninger"`,
		layout: 'htx-fields-of-study',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'science'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'society', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'languages', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'art', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'finance', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'media',
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'technology'
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 4,
		taskId: 'education-fields-4',
		lockedById: 'education-fields-3',
		subtype: 'images',
		title: 'Opgave 3B',
		text: `<b>Gæt studieretningen!</b>
			<br /><br />Vi har samlet nogle emojis, der viser fagene og temaerne i en studieretning. 
			<br /><br />Kan I finde ud af, hvilken det er? 
			<br /><br /><b>Tryk på det rigtige svar og se, om I har styr på studieretningerne!</b>`,
		hintText: `Prøv at matche ikonerne med et fagområde.`,
		layout: 'hhx-fields-emojis',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'society', title: `Samfund`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'languages', title: `Sprog`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'it', title: `IT`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'math', title: `Matematik`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'scales', type: 'image', categoryIds: ['society']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'court-house', type: 'image', categoryIds: ['society']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'speaking', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'earth', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'flag', type: 'image', categoryIds: ['languages']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'laptop', type: 'image', categoryIds: ['it']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'programming', type: 'image', categoryIds: ['it']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'ruler', type: 'image', categoryIds: ['math']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'numbers', type: 'image', categoryIds: ['math']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 'graph', type: 'image', categoryIds: ['math']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 5,
		taskId: 'education-fields-5',
		title: 'Opgave 4',
		text: `Vi leger, at I er elever, der skal vælge en studieretning. 
			<br /><br /><b>Hvad tror I, at man oplever undervejs?</b>
			<br /><br />Sæt trinnene i den rækkefølge, de typisk sker.`,
		hintText: `Overvej, hvad der logisk sker først, når man starter.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Introforløb på gymnasiet`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Overvej interesser og fremtid`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælg og søg en studieretning`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Start på fagene`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Arbejd med fag og eksamen`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Gå til eksamen i de valgte fag`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 6,
		title: 'Opgave 5',
		taskId: 'education-fields-6',
		text: `Hvornår vælger man sin studieretning på HHX?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `Studieretning vælges først efter grundforløbet, fordi eleverne skal prøve fagene af, inden de træffer et endeligt valg.`,
		image: 'hhx-education-fields-6',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Første skoledag'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Før man starter',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'I slutningen af grundforløbet', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Når man afslutter 1. g'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Det kan man selv bestemme'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Når man afslutter 2. g'
			}),
		],
	}),
	/* Case 5 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 1,
		taskId: 'education-sort-required',
		title: 'Opgave 1A',
		text: `På HHX vælger du selv nogle fag – men de fleste er obligatoriske. 
			<br /><br /><b>Hvilke af disse tror I bl.a., alle skal have?</b>`,
		hintText: `I kan finde svaret her: https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/merkantil-studentereksamen-hhx`,
		popupText: `De obligatoriske fag er valgt, så alle får en bred grundpakke.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'required', 
				title: `Obligatoriske fag`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'notRequired', 
				title: `Ikke obligatoriske fag`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Historie`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Matematik`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Erhvervsjura`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Virksomhedsøkonomi`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `IT`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Samfundsfag`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8, text: `Tysk`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 9, text: `Religion`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 10, text: `Musik`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 11, text: `Kemi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 12, text: `Biologi`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 13, text: `Fysik`, categoryIds: ['notRequired']
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 2,
		taskId: 'education-sort-levels',
		title: 'Opgave 1B',
		lockedById: 'education-sort-required',
		text: `<b>På HHX er fagene på tre niveauer: A, B og C – og A er det højeste.</b>
			<br /><br />Hvilket niveau har man som udgangspunkt de her fag på?`,
		hintText: `I kan finde svaret her: https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/merkantil-studentereksamen-hhx`,
		popupText: `A-, B- og C-niveau er et system, der sikrer du kan blive dygtigere, hvert niveau tager et skoleår at gennemføre.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'a', 
				title: `A-niveau`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'b', 
				title: `B-niveau`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'c', 
				title: `C-niveau`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk`, categoryIds: ['a']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Engelsk`, categoryIds: ['a']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Matematik`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `International økonomi`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Virksomhedsøkonomi`, categoryIds: ['b']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Erhvervsjura`, categoryIds: ['c']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Samfundsfag`, categoryIds: ['c']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 5,
		taskNumber: 3,
		title: 'Opgave 2',
		taskId: 'education-rules',
		text: `<b>Hvordan fungerer fagene på HHX?</b>
			<br /><br />Kan I spotte, hvilke regler der gælder for A-niveaufag – og hvad man selv kan vælge? 
			<br /><br /><b>Vælg de rigtige svar!</b>`,
		hintText: `I kan finde svaret her: https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/merkantil-studentereksamen-hhx`,
		popupText: `Reglen om mindst fire A-niveaufag betyder, at alle elever kommer igennem et højt fagligt niveau.`,
		image: 'hhx-education-required-subjects-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Som elev på HHX skal du have mindst fire fag på A-niveau', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Som elev på HHX skal du have mindst tre fag på A-niveau'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Man kan godt vælge at få endnu flere A-niveau fag hvis man selv ønsker det', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Man kan ikke vælge at få flere A-niveau fag hvis man selv ønsker det'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Man kan vælge de samme valgfag på alle HHX gymnasier i Danmark'
			}),
		],
	}),
	/* Case 6 */
	
	// Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1',
	// 	taskId: 'education-spot-errors-sfx-room',
	// 	layout: 'fields-sfx-classroom',
	// 	text: `Velkommen til et af gymnasiets store lokaler! Men nogle af eleverne passer vist ikke helt ind på et typisk STX-gymnasium. Find fejlene – og tryk OK, når I tror, I har dem alle.`,
	// 	hintText: `Nogle af personerne laver noget, man aldrig gør på STX.`,
	// 	errors: [
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'sawing'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'money'}),
	// 		Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tool'})
	// 	]
	// }),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	caseId: 4,
	// 	taskNumber: 2,
	// 	taskId: 'education-order-science-day',
	// 	title: 'Opgave 2',
	// 	text: `Hvordan tror I, en helt dag kan se ud for en elev på naturvidenskabs-studieretningen, som også selv elsker astronomi? Sæt dagen i den rækkefølge, I synes passer bedst.`,
	// 	hintText: `Her er det en god ide at tale sammen i gruppen og gætte sig frem`,
	// 	popupText: `Dagen følger et naturligt flow, men kan selvfølgelig være forskelligt mellem elever.`,
	// 	layout: 'halfdouble-height',
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 1, text: `Vågne op og spise morgenmad`, correctOrderNumbers: [1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 2, text: `Tage bussen eller cykle til skolen`, correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 3, text: `Starte dagen med en naturvidenskabstime med forsøg`, correctOrderNumbers: [3]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 4, text: `Hygge med venner i frikvarteret`, correctOrderNumbers: [4]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 5, text: `Arbejde på et projekt i biologilokalet`, correctOrderNumbers: [5]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 6, text: `Lave lektier derhjemme`, correctOrderNumbers: [6]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 7, text: `Chille til en nice film om rummet`, correctOrderNumbers: [7]
	// 		})
	// 	]
	// }),
	// Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
	// 	caseId: 6,
	// 	taskNumber: 5,
	// 	title: 'Opgave 4',
	// 	taskId: 'education-paper-doll-chemistry',
	// 	layout: 'fields-chemistry',
	// 	avatarId: 'avatar-3',
	// 	text: `Kemi er et fag, mange synes er spændende. Hvad tror I, man arbejder med i laboratoriet?
	// 		<br />Klik OK, når I synes, I har valgt de rigtige ting.`,
	// 	hintText: `Tænk på ting, man bruger til forsøg – ikke hospitalet.`,
	// 	popupText: `En bunsenbrænder og kitler hører til naturvidenskab på HTX, mens ting som stetoskop eller radioaktivt symbol ikke bruges i gymnasiet.`,
	// 	items: [
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'bunsen', title: 'Bunsenbrænder', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'lab-coat-grey', title: 'Kittel', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'tube', title: 'Reagensglas', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'dna', title: 'DNA streng', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'syringe', title: 'Sprøjte med nål'
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'radioactive', title: 'Radioaktivt logo'
	// 		}),
	// 		Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
	// 			id: 'stethoscope', title: 'Medicinsk stetoskop'
	// 		}),

	// 	]
	// }),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'hhxedu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};